import RegistrationConfirmation from './RegistrationConfirmation';

export default RegistrationConfirmation;